/* -------------------------------------------------------------------------------------------------
Restricted - Copyright (C) Siemens Healthcare GmbH/Siemens Medical Solutions USA, Inc., 2019. All rights reserved
------------------------------------------------------------------------------------------------- */
import { css, html, LitElement } from 'lit-element';
import '../../styles';

/**
 * @prop {String} selected - *hide
 * @prop {String} role - *hide
 * @prop {String} group - *hide
 */
export class SHMenuGroup extends LitElement {
  static get properties() {
    return {
      selected: { type: String, reflect: true },
      group: { type: String, reflect: true },
      role: { type: String, reflect: true },
    };
  }
  static get styles() {
    return [
      css`
        :host {
          width: 100%;
          display: block;
        }

        .menu-wrapper {
          display: flex;
          flex-direction: column;
          width: 100%;
        }

        #grouped {
          flex: 1;
          box-sizing: border-box;
          display: flex;
          flex-direction: column;
          overflow: hidden;
        }

        .menu-wrapper > ::slotted(sh-menu-item) {
          margin-top: 0.5rem;
        }
        .menu-wrapper > ::slotted(*:first-child) {
          margin-top: 0rem !important;
        }
        /* touch */
        @media (any-pointer: coarse) {
          .menu-wrapper > ::slotted(sh-menu-item) {
            margin-top: 1rem;
          }
        }
      `,
    ];
  }

  render() {
    return html`
      <div class="menu-wrapper">
        <slot id="grouped" @slotchange="${this._handleSlotChange}"></slot>
      </div>
    `;
  }
  constructor() {
    super();
    this.selected = 'defaultId';
    this.group = 'defaultGroup';
    this.role = 'listgroup';
  }
  connectedCallback() {
    super.connectedCallback();
    this._handleMenuItemActiveChange = this._activeHandle.bind(this);
    this.addEventListener('clicked', this._handleMenuItemActiveChange);
  }
  _activeHandle() {
    let childElement;
    childElement = this.querySelectorAll('sh-menu-item[active]');
    for (let i = 0; i < childElement.length; i++) {
      childElement[i].removeAttribute('active');
    }
  }
  _handleSlotChange() {
    for (let i = 0; i < this.children.length; i++) {
      if (!this.children[i].hasAttribute('disabled')) {
        this.children[i].setAttribute('tabindex', '0');
      }
    }
  }
  disconnectedCallback() {
    this.removeEventListener('clicked', this._handleMenuItemActiveChange);
    super.disconnectedCallback();
  }
}
customElements.define('sh-menu-group', SHMenuGroup);
